// Port of api/fuel/app/classes/model/game/category.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'game_category',
	prefix: '',
	key: 'game_category_id',
	fields: {
		game_category_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		category_id: Model.SCHEMA_NUMBER
	}
})
